import { query, where, getDocs } from "firebase/firestore";
import GoalsModel, { goalTypes } from "./models/GoalsModel";

export const getCurrentGoals = async (user, setGoals) => {
    if (!user || !user.uid) return;
  
    const q = query(GoalsModel.goalsCollection, where("uid", "==", user.uid));
  
    try {
      const querySnapshot = await getDocs(q);
      const newGoals = querySnapshot.docs.map(doc => ({
        ...doc.data(),
        id: doc.id,
      }));
      newGoals.sort((a, b) => (a.index < b.index ? -1 : 1));

        newGoals.sort((a, b) => {
        const goalTypesArray = Object.keys(goalTypes);
        const aIndex = goalTypesArray.indexOf(a.type);
        const bIndex = goalTypesArray.indexOf(b.type);

        if (aIndex === -1) return 1; // a has no goal type, so it goes last
        if (bIndex === -1) return -1; // b has no goal type, so it goes last

        return aIndex - bIndex; // sort by goal type index
        });

  
      setGoals(newGoals);
    } catch (error) {
      console.error("Error fetching goals:", error);
      // Handle the error appropriately
    }
  };

export const goalDidToday = (goalDays) => {
  const toHaveDisplayValueDate = new Date();
  const toHaveDisplayComponents = {
    day: toHaveDisplayValueDate.getDate(),
    month: toHaveDisplayValueDate.getMonth() + 1,
    year: toHaveDisplayValueDate.getFullYear(),
  };

  const didToday = goalDays.find((d) => {
    const date = new Date(d);
    const day = date.getDate();
    const month = date.getMonth() + 1;
    const year = date.getFullYear();

    return (
      day === toHaveDisplayComponents.day &&
      month === toHaveDisplayComponents.month &&
      year === toHaveDisplayComponents.year
    );
  });

  return didToday === undefined;
};

export function shuffleArray(array) {
  let currentIndex = array.length,
    randomIndex;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
}
